// Importing necessary libraries and files
import React, { useState } from "react"; 
import { Link, useNavigate } from "react-router-dom"; 
import "./ForgotPassword.css";

const ForgotPassword = () => {
  // Initializing state variables:
  const [email, setEmail] = useState(""); 
  const [message, setMessage] = useState(""); 
  const [error, setError] = useState(""); 
  const navigate = useNavigate(); 
  const API_URL = process.env.REACT_APP_API_URL || 'https://pyate-backend-production-9749.up.railway.app';

  const handleChange = (e) => {
    // Updates the email state with the user's input.
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevents the default form submission behavior.

    if (!email) {
      // Validates if the email field is empty.
      setError("Email is required!");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Regular expression to validate email format.
    if (!emailRegex.test(email)) {
      // Checks if the email is in a valid format.
      setError("Please enter a valid email address.");
      return;
    }

    // Resets error and message state if validations pass.
    setError("");
    setMessage("");

    try {
      // Sends a POST request to the server with the user's email.
      const response = await fetch(`${API_URL}/user/forgotpass_api`, {
        method: "POST", // Specifies the HTTP method.
        headers: { "Content-Type": "application/json" }, 
        body: JSON.stringify({ email }), // Converts the email to a JSON string.
      });

      const data = await response.json(); // Parses the JSON response from the server.

      if (response.ok) {
        // If the response is successful:
        setMessage("Password reset link has been sent to your email."); // Display success message.

        setTimeout(() => {
          navigate("/"); 
        }, 1000); 
      } else {
        // If the server returns an error:
        setError(data.error || "Something went wrong."); // Display the server error or a fallback message.
      }
    } catch (error) {
      // Handles any network or unexpected errors.
      console.error("Error:", error);
      setError("Failed to send reset link. Please try again later.");
    }
  };

  return (
    <div className="forgot-password-container">
      {/* The container div for styling the component */}
      <h2 className="forgot-password-header">Forgot Password</h2>
      {/* Header for the page */}

      <form onSubmit={handleSubmit} className="forgot-password-form">
        <div className="input-group">
          <label htmlFor="email">Enter your email address:</label>
          {/* Label for accessibility */}
          <input
            type="email" 
            id="email" 
            name="email" 
            value={email} 
            onChange={handleChange} 
            placeholder="Your email"
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        {/* Displays an error message if `error` state is set */}
        {message && <p className="success-message">{message}</p>}
        {/* Displays a success message if `message` state is set */}
        <button type="submit" className="reset-button">
          Send Reset Link
        </button>
      </form>
      <p className="back-to-login">
        <Link to="/">Back to Login</Link>
      </p>
    </div>
  );
};

export default ForgotPassword;

